import Championship from "./championship";
import Match from "./MatchAxios";
import Paper from "./PaperAxios";
import Edition from "./championship/edition";

export default {
  Championship,
  Match,
  Paper,
  Edition,
};
